import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/** @internal */
export var knownContextKeys = {
  span: Symbol.for("@azure/core-tracing span"),
  namespace: Symbol.for("@azure/core-tracing namespace")
};
/**
 * Creates a new {@link TracingContext} with the given options.
 * @param options - A set of known keys that may be set on the context.
 * @returns A new {@link TracingContext} with the given options.
 *
 * @internal
 */

export function createTracingContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = new TracingContextImpl(options.parentContext);

  if (options.span) {
    context = context.setValue(knownContextKeys.span, options.span);
  }

  if (options.namespace) {
    context = context.setValue(knownContextKeys.namespace, options.namespace);
  }

  return context;
}
/** @internal */

export var TracingContextImpl = /*#__PURE__*/function () {
  function TracingContextImpl(initialContext) {
    _classCallCheck(this, TracingContextImpl);

    this._contextMap = initialContext instanceof TracingContextImpl ? new Map(initialContext._contextMap) : new Map();
  }

  _createClass(TracingContextImpl, [{
    key: "setValue",
    value: function setValue(key, value) {
      var newContext = new TracingContextImpl(this);

      newContext._contextMap.set(key, value);

      return newContext;
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      return this._contextMap.get(key);
    }
  }, {
    key: "deleteValue",
    value: function deleteValue(key) {
      var newContext = new TracingContextImpl(this);

      newContext._contextMap.delete(key);

      return newContext;
    }
  }]);

  return TracingContextImpl;
}();